import type { FormBuilderField } from "../../types/formBuilder";
import { resolveFieldType } from "../forms/normalizeFieldType";

export type ListChoicesMode = "manual" | "dependent" | "url";

export function isListFieldType(type: string | null | undefined): boolean {
  const resolved = resolveFieldType(type);
  return (
    resolved === "select" ||
    resolved === "choice" ||
    resolved === "multiple-choice"
  );
}

export function inferListChoicesMode(
  field: Pick<
    FormBuilderField,
    "choicesByField" | "choicesUrl" | "choicesByUrl"
  >,
): ListChoicesMode {
  if (field.choicesByField.trim()) return "dependent";
  if (field.choicesUrl.trim() || field.choicesByUrl.trim()) return "url";
  return "manual";
}

export function listChoicesMode(
  field: Pick<
    FormBuilderField,
    "choicesByField" | "choicesUrl" | "choicesByUrl" | "choicesListMode"
  >,
): ListChoicesMode {
  if (field.choicesByField.trim()) return "dependent";
  if (field.choicesUrl.trim()) return "url";
  if (field.choicesListMode) return field.choicesListMode;
  return inferListChoicesMode(field);
}

export function patchForListChoicesMode(
  mode: ListChoicesMode,
  current: FormBuilderField,
  preferredSource = "",
): Partial<FormBuilderField> {
  if (mode === "manual") {
    return {
      choicesListMode: "manual",
      choicesByField: "",
      choicesByMapText: {},
      choicesByUrl: "",
      choicesByPath: "",
      choicesByItem: "",
      choicesByValue: "",
      choicesValue: "",
      choicesUrl: "",
      choicesPath: "",
      choicesItem: "",
    };
  }

  if (mode === "url") {
    return {
      choicesListMode: "url",
      choicesText: "",
      choicesByField: "",
      choicesByMapText: {},
      choicesByUrl: "",
      choicesByPath: "",
      choicesByItem: "",
      choicesByValue: "",
      choicesUrl: current.choicesUrl,
      choicesPath: current.choicesPath,
      choicesItem: current.choicesItem,
      choicesValue: current.choicesValue,
    };
  }

  return {
    choicesListMode: "dependent",
    choicesText: "",
    choicesUrl: "",
    choicesPath: "",
    choicesItem: "",
    choicesValue: "",
    choicesByField: current.choicesByField.trim() || preferredSource,
    choicesByMapText: current.choicesByMapText,
    choicesByUrl: current.choicesByUrl,
    choicesByPath: current.choicesByPath,
    choicesByItem: current.choicesByItem,
    choicesByValue: current.choicesByValue,
  };
}

export function clearListChoicesPatch(): Partial<FormBuilderField> {
  return {
    choicesListMode: "manual",
    choicesText: "",
    quizCorrect: [],
    quizPoints: 1,
    choicesUrl: "",
    choicesPath: "",
    choicesItem: "",
    choicesValue: "",
    choicesByField: "",
    choicesByMapText: {},
    choicesByUrl: "",
    choicesByPath: "",
    choicesByItem: "",
    choicesByValue: "",
  };
}
